/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { paletteTokens } from './paletteVariables';

export const getLightThemeVariables = (palette = paletteTokens) =>
  ({
    button: {
      primary: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[100],
        label: palette.dynamicContrast.primary[100],
        border: palette.neutral.darkAlpha[600],
        disabled: palette.neutral.grey[150],
      },
      secondary: {
        default: palette.neutral.grey[150],
        hover: palette.neutral.grey[200],
        pressed: palette.neutral.grey[150],
        disabled: palette.neutral.grey[150],
        label: palette.neutral.grey[800],
        border: palette.neutral.grey[300],
      },
      ghost: {
        hover: palette.brand.secondary[200],
        pressed: palette.brand.secondary[100],
        disabled: palette.neutral.grey[450],
        default: palette.brand.secondary[100],
      },
      outline: {
        default: palette.neutral.grey[300],
        hover: palette.neutral.grey[400],
        pressed: palette.neutral.grey[350],
        label: palette.neutral.grey[800],
      },
      destructive: {
        default: palette.alert.negative[350],
        hover: palette.alert.negative[350],
        pressed: palette.alert.negative[350],
        disabled: palette.neutral.grey[150],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[600],
      },
      upgrade: {
        default: palette.pro.primary[100],
        hover: palette.pro.primary[150],
        pressed: palette.pro.primary[150],
        disabled: palette.neutral.grey[150],
        label: palette.neutral.grey[100],
        border: palette.neutral.darkAlpha[600],
      },
      disabled: { label: palette.neutral.grey[450] },
      focused: {
        default: palette.neutral.grey[700],
        upgrade: palette.pro.primary[100],
        desctructive: palette.alert.negative[350],
      },
      divider: {
        dark: palette.neutral.darkAlpha[600],
        light: palette.neutral.lightAlpha[450],
      },
      secondaryAlt: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[150],
        pressed: palette.neutral.grey[200],
        disabled: palette.neutral.grey[150],
        label: palette.neutral.grey[800],
        border: palette.neutral.grey[300],
      },
      link: {
        default: palette.brand.primary[200],
        hover: palette.brand.primary[250],
        pressed: palette.brand.primary[250],
        disabled: palette.neutral.grey[450],
      },
      outlineDestructive: {
        default: palette.neutral.grey[300],
        hover: palette.neutral.grey[400],
        pressed: palette.neutral.grey[350],
        label: palette.alert.negative[350],
      },
      loading: { label: palette.neutral.grey[800] },
    },
    text: {
      generic: {
        primary: palette.neutral.grey[800],
        secondary: palette.neutral.grey[650],
        tertiary: palette.neutral.grey[550],
        badge: palette.neutral.grey[100],
        brandLight: palette.brand.primary[200],
        brand: palette.brand.secondary[100],
        positive: palette.alert.positive[400],
        warning: palette.alert.notice[500],
        negative: palette.alert.negative[350],
      },
      interactive: {
        active: palette.brand.secondary[100],
        disabled: palette.neutral.grey[450],
        default: palette.neutral.grey[550],
      },
      link: {
        default: palette.brand.primary[200],
        hover: palette.brand.primary[250],
        disabled: palette.neutral.grey[450],
      },
    },
    background: {
      interactive: {
        canvas: palette.neutral.grey[100],
        hover: palette.neutral.grey[200],
        inactive: palette.neutral.grey[250],
        canvasHover: palette.neutral.grey[200],
        selected: palette.neutral.grey[250],
        disabledHover: palette.neutral.grey[150],
      },
      primary: palette.neutral.grey[150],
      secondary: palette.neutral.grey[250],
      tertiary: palette.neutral.grey[350],
      default: {
        noCamera: palette.neutral.grey[850],
        backend: palette.neutral.grey[150],
        fullwhite: palette.neutral.grey[100],
        fixedheader: palette.neutral.grey[100],
        icon: palette.neutral.darkAlpha[350],
        preview: palette.neutral.grey[300],
      },
      dimmingLayer: palette.neutral.darkAlpha[300],
      dimmingLayerLight: palette.neutral.darkAlpha[450],
    },
    icon: {
      primary: palette.neutral.grey[800],
      onBrand: palette.neutral.grey[100],
      interactive: {
        disabled: palette.neutral.grey[450],
        default: palette.neutral.grey[650],
        hover: palette.neutral.grey[800],
        negative: palette.alert.negative[350],
        upgrade: palette.pro.primary[100],
        active: palette.brand.primary[100],
      },
      positive: palette.alert.positive[350],
      notice: palette.alert.notice[350],
      negative: palette.alert.negative[350],
      secondary: palette.neutral.grey[650],
      brand: palette.brand.secondary[100],
      tertiary: palette.neutral.grey[550],
      brandlight: palette.brand.primary[200],
      upgrade: palette.pro.primary[100],
    },
    border: {
      brand: palette.brand.secondary[100],
      primary: palette.neutral.grey[300],
      interactive: {
        hover: palette.neutral.grey[300],
        disabled: palette.neutral.grey[200],
        default: palette.brand.primary[150],
        negative: palette.alert.negative[300],
        negativeHover: palette.alert.negative[350],
        pressed: palette.neutral.grey[500],
        selected: palette.brand.primary[50],
        negativeFocused: palette.alert.negative[200],
        defaultFocused: palette.brand.primary[50],
        upgradeFocused: palette.pro.primary[50],
        indicatorFocused: palette.neutral.grey[700],
        indicatorNegativeFocused: palette.alert.negative[350],
        indicatorUpgradeFocused: palette.pro.primary[100],
      },
      secondary: palette.neutral.grey[850],
      tertiary: palette.neutral.darkAlpha[500],
      default: palette.neutral.grey[250],
    },
    input: {
      background: {
        default: palette.neutral.grey[100],
        disabled: palette.neutral.darkAlpha[700],
      },
      border: {
        default: palette.neutral.grey[300],
        active: palette.brand.primary[150],
        error: palette.alert.negative[300],
        errorActive: palette.alert.negative[350],
        focused: palette.brand.primary[50],
        errorFocused: palette.alert.negative[200],
      },
    },
    tooltip: {
      background: palette.neutral.grey[750],
      border: palette.neutral.grey[600],
    },
    switch: {
      default: {
        default: palette.neutral.grey[350],
        hover: palette.neutral.grey[400],
        pressed: palette.neutral.grey[450],
        disabled: palette.neutral.grey[150],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.brand.primary[50],
      },
      knob: {
        default: palette.neutral.grey[150],
        disabled: palette.neutral.grey[150],
      },
    },
    toast: {
      notification: {
        background: palette.neutral.grey[750],
        border: palette.neutral.grey[600],
      },
    },
    keystroke: {
      background: palette.neutral.grey[150],
      border: palette.neutral.darkAlpha[450],
    },
    popover: {
      background: palette.neutral.lightAlpha[100],
      border: palette.neutral.grey[250],
    },
    incall: {
      icon: {
        background: {
          interactive: {
            default: palette.neutral.darkAlpha[600],
            hover: palette.neutral.grey[200],
            active: palette.neutral.lightAlpha[100],
            disabled: palette.neutral.darkAlpha[650],
            navigation: palette.neutral.darkAlpha[350],
          },
        },
        fill: {
          interactive: {
            default: palette.neutral.grey[500],
            hover: palette.neutral.grey[450],
            active: palette.brand.primary[100],
            disabled: palette.neutral.darkAlpha[600],
          },
        },
      },
      text: {
        interactive: { disabled: palette.neutral.darkAlpha[400] },
        input: palette.neutral.grey[950],
        placeholder: palette.neutral.grey[450],
      },
      background: {
        canvasDark: palette.neutral.grey[850],
        canvasLight: palette.neutral.grey[750],
        base: palette.neutral.grey[150],
      },
      nametag: {
        background: palette.neutral.grey[800],
        border: palette.neutral.grey[650],
      },
      controlbar: {
        cells: {
          hover: palette.neutral.grey[600],
          selected: palette.neutral.lightAlpha[100],
          selectedHover: palette.neutral.lightAlpha[150],
          default: palette.neutral.grey[650],
          active: palette.neutral.grey[700],
          negative: palette.alert.negative[350],
          negativeHover: palette.alert.negative[400],
        },
        icons: {
          default: palette.neutral.grey[800],
          disabled: palette.neutral.grey[500],
          upgrade: palette.pro.primary[100],
          negative: palette.alert.negative[350],
          active: palette.brand.primary[200],
        },
        base: {
          background: palette.neutral.grey[850],
          border: 'rgba(255, 255, 255, 0)',
        },
      },
      controls: {
        cell: {
          default: palette.neutral.grey[750],
          hover: palette.neutral.grey[600],
          border: 'rgba(255, 255, 255, 0)',
          disabled: palette.neutral.grey[650],
          active: palette.neutral.grey[600],
        },
        icons: {
          default: palette.neutral.grey[100],
          disabled: palette.neutral.grey[500],
        },
      },
      tab: {
        cells: {
          default: 'rgba(255, 255, 255, 0)',
          active: palette.neutral.lightAlpha[600],
          hover: palette.neutral.grey[700],
          selected: 'rgba(255, 255, 255, 0)',
        },
        icons: { default: palette.neutral.grey[100] },
      },
      timer: { background: palette.neutral.grey[700] },
    },
    iconButton: {
      icon: {
        default: palette.neutral.grey[600],
        disabled: palette.neutral.grey[450],
        destructive: palette.alert.negative[350],
        defaultAlpha: palette.neutral.grey[200],
      },
      background: {
        default: {
          disabled: palette.neutral.grey[150],
          default: palette.neutral.grey[250],
          hover: palette.neutral.grey[350],
          active: palette.neutral.grey[350],
          pressed: palette.neutral.grey[400],
          focused: palette.neutral.grey[250],
          disabledHover: palette.neutral.grey[150],
        },
        subtle: {
          default: 'rgba(255, 255, 255, 0)',
          disabled: 'rgba(255, 255, 255, 0)',
          focused: palette.neutral.darkAlpha[500],
          active: palette.neutral.darkAlpha[450],
          disabledHover: palette.neutral.darkAlpha[600],
          pressed: palette.neutral.darkAlpha[400],
          hover: palette.neutral.darkAlpha[500],
        },
        tinted: {
          disabled: 'rgba(255, 255, 255, 0)',
          pressed: palette.brand.secondary[50],
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.brand.secondary[40],
          disabledHover: palette.brand.secondary[30],
          active: palette.brand.secondary[50],
          focused: palette.brand.secondary[40],
        },
        tintedWithStroke: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.brand.secondary[50],
          pressed: palette.brand.secondary[60],
          focused: palette.brand.secondary[50],
          active: palette.brand.secondary[60],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.brand.secondary[40],
          border: palette.neutral.grey[400],
        },
        defaultDestructive: {
          default: palette.neutral.darkAlpha[450],
          hover: palette.alert.negative[100],
          pressed: palette.alert.negative[150],
          focused: palette.alert.negative[100],
          active: palette.alert.negative[150],
          disabled: palette.neutral.darkAlpha[450],
          disabledHover: palette.neutral.darkAlpha[500],
        },
        subtleDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[100],
          pressed: palette.alert.negative[150],
          focused: palette.alert.negative[100],
          active: palette.alert.negative[150],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.neutral.darkAlpha[500],
        },
        tintedDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[100],
          pressed: palette.alert.negative[150],
          focused: palette.alert.negative[100],
          active: palette.alert.negative[150],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.brand.secondary[40],
        },
        tintedwithstrokeDestructive: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.alert.negative[100],
          pressed: palette.alert.negative[150],
          focused: palette.alert.negative[100],
          active: palette.alert.negative[150],
          disabled: 'rgba(255, 255, 255, 0)',
          disabledHover: palette.brand.secondary[40],
          border: palette.neutral.grey[300],
        },
        defaultAlpha: {
          default: palette.neutral.lightAlpha[500],
          hover: palette.neutral.lightAlpha[550],
          pressed: palette.neutral.lightAlpha[450],
          focused: palette.neutral.lightAlpha[500],
          active: palette.neutral.lightAlpha[450],
          disabled: palette.neutral.lightAlpha[500],
          disabledHover: palette.neutral.lightAlpha[650],
        },
        defaultAlphaDestructive: {
          default: palette.neutral.darkAlpha[450],
          hover: palette.alert.negative[100],
          pressed: palette.alert.negative[150],
          focused: palette.alert.negative[100],
          active: palette.alert.negative[150],
          disabled: palette.neutral.darkAlpha[450],
          disabledHover: palette.neutral.darkAlpha[500],
        },
      },
    },
    menu: {
      background: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[200],
        selected: palette.neutral.grey[250],
        border: palette.neutral.grey[200],
        destructiveHover: palette.alert.negative[100],
        disabledHover: palette.neutral.grey[150],
      },
      item: {
        default: palette.neutral.grey[800],
        hover: palette.neutral.grey[800],
        selected: palette.neutral.grey[800],
        disabled: palette.neutral.grey[450],
      },
    },
    sidebar: {
      background: {
        active: palette.brand.secondary[30],
        hover: palette.brand.secondary[20],
      },
    },
    item: {
      selected: palette.brand.secondary[100],
      default: palette.neutral.grey[550],
    },
    modal: {
      background: palette.neutral.lightAlpha[100],
      border: palette.neutral.grey[250],
      cell: palette.neutral.grey[150],
      divider: palette.neutral.grey[350],
      headerBackground: palette.neutral.grey[150],
      hover: palette.neutral.grey[250],
    },
    patientQueuePanels: {
      background: palette.neutral.grey[100],
      border: palette.neutral.grey[250],
      cell: palette.neutral.grey[150],
    },
    radioButton: {
      default: {
        default: palette.neutral.grey[400],
        hover: palette.brand.primary[100],
        pressed: palette.brand.primary[200],
        disabled: palette.neutral.grey[200],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.brand.primary[50],
      },
      background: palette.neutral.grey[100],
      selector: {
        default: palette.dynamicContrast.primary[100],
        disabled: palette.neutral.grey[450],
      },
    },
    segmentedControl: {
      background: palette.neutral.grey[200],
      default: {
        border: 'rgba(255, 255, 255, 0)',
        background: 'rgba(255, 255, 255, 0)',
        text: palette.neutral.grey[650],
      },
      hover: {
        background: palette.neutral.darkAlpha[600],
        border: 'rgba(255, 255, 255, 0)',
        text: palette.neutral.grey[650],
      },
      active: {
        background: palette.neutral.grey[100],
        border: palette.neutral.grey[350],
        text: palette.neutral.grey[800],
      },
    },
    checkbox: {
      background: palette.neutral.grey[100],
      default: {
        default: palette.neutral.grey[350],
        hover: palette.brand.primary[100],
        pressed: palette.brand.primary[200],
      },
      active: {
        default: palette.brand.primary[100],
        hover: palette.brand.primary[150],
        pressed: palette.brand.primary[200],
        disabled: palette.brand.primary[50],
      },
      disabled: {
        background: palette.neutral.grey[200],
        border: palette.neutral.grey[300],
      },
      error: {
        error: palette.alert.negative[300],
        hover: palette.alert.negative[350],
        pressed: palette.alert.negative[250],
      },
      container: {
        default: palette.neutral.grey[200],
        error: palette.alert.negative[100],
      },
      selector: {
        default: palette.dynamicContrast.primary[100],
        disabled: palette.neutral.grey[450],
      },
    },
    filter: {
      default: palette.neutral.grey[200],
      hover: palette.neutral.grey[200],
      active: palette.neutral.grey[250],
      disabled: palette.neutral.grey[150],
    },
    callout: {
      neutral: palette.neutral.grey[200],
      success: palette.alert.positive[150],
      informative: palette.alert.informative[150],
      notice: palette.alert.notice[150],
      error: palette.alert.negative[150],
      upgrade: palette.pro.secondary[10],
      beta: palette.brand.secondary[20],
    },
    badge: {
      upgrade: {
        active: palette.pro.primary[100],
        text: palette.neutral.grey[100],
      },
      inactive: {
        text: palette.neutral.grey[550],
        background: palette.neutral.grey[250],
      },
      marketing: {
        background: palette.brand.primary[100],
        text: palette.dynamicContrast.primary[100],
      },
      beta: {
        background: palette.neutral.grey[100],
        text: palette.neutral.grey[600],
        stroke: palette.neutral.grey[600],
      },
    },
    subscription: {
      proFeatureContainer: {
        background: palette.pro.secondary[25],
        border: palette.pro.primary[15],
      },
      upgradeIcon: {
        icon: palette.pro.primary[100],
        background: palette.pro.primary[15],
      },
    },
    connectionStatus: {
      base: palette.neutral.grey[100],
      active: {
        good: palette.alert.positive[350],
        medium: palette.alert.notice[350],
        poor: palette.alert.negative[350],
        none: palette.neutral.grey[550],
      },
      inactive: {
        good: palette.alert.positive[200],
        medium: palette.alert.notice[200],
        poor: palette.alert.negative[200],
      },
    },
    status: {
      positive: palette.alert.positive[350],
      negative: palette.alert.negative[350],
      notice: palette.alert.notice[350],
      informative: palette.alert.informative[350],
      neutral: palette.neutral.grey[600],
      baseLight: palette.neutral.grey[100],
      baseDark: palette.neutral.grey[900],
      border: palette.neutral.grey[100],
    },
    numberBadge: {
      alert: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
      default: {
        background: palette.neutral.grey[250],
        text: palette.neutral.grey[800],
      },
      list: {
        background: palette.brand.primary[100],
        text: palette.dynamicContrast.primary[100],
      },
      plain: {
        background: palette.neutral.grey[100],
        text: palette.neutral.grey[800],
        border: palette.neutral.grey[250],
      },
      message: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
    },
    dashboard: {
      navigation: {
        background: {
          default: 'rgba(255, 255, 255, 0)',
          hover: palette.neutral.grey[250],
          selected: palette.neutral.grey[300],
        },
        label: {
          default: palette.neutral.grey[550],
          hover: palette.neutral.grey[800],
          selected: palette.neutral.grey[800],
          disabled: palette.neutral.grey[450],
        },
        avatarborder: {
          default: palette.brand.secondary[50],
          hover: palette.brand.secondary[50],
          selected: palette.brand.secondary[50],
        },
      },
      default: palette.brand.secondary[50],
      hover: palette.brand.secondary[50],
      selected: palette.brand.secondary[50],
      content: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[300],
      },
    },
    form: { divider: { border: palette.neutral.grey[200] } },
    tabbar: {
      bar: { background: palette.neutral.grey[125] },
      tabs: {
        default: {
          background: palette.neutral.grey[100],
          border: palette.neutral.grey[300],
          label: palette.neutral.grey[550],
        },
        hover: {
          background: palette.neutral.grey[200],
          border: palette.neutral.grey[300],
          label: palette.neutral.grey[550],
        },
        selected: {
          background: palette.neutral.grey[300],
          border: palette.neutral.grey[300],
          label: palette.neutral.grey[800],
        },
      },
    },
    datepicker: {
      base: {
        background: palette.neutral.lightAlpha[100],
        border: palette.neutral.grey[250],
      },
      cells: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[250],
        selected: palette.neutral.grey[400],
        todayborder: palette.neutral.grey[400],
        selctedinbetween: palette.neutral.grey[150],
      },
    },
    interactiveTag: {
      default: { background: palette.neutral.grey[200] },
      hover: { background: palette.neutral.grey[250] },
      focused: {
        background: palette.brand.primary[25],
        border: palette.brand.primary[150],
      },
      error: { background: palette.alert.negative[100] },
      errorFocused: {
        border: palette.alert.negative[300],
        background: palette.alert.negative[100],
      },
      new: {
        background: palette.brand.primary[25],
        text: palette.brand.primary[200],
        icon: palette.brand.primary[200],
      },
    },
    videotile: {
      noCamera: palette.neutral.grey[900],
      disabled: palette.neutral.grey[200],
      border: palette.neutral.grey[250],
      speakingBorder: palette.brand.primary[150],
    },
    rating: {
      default: palette.neutral.grey[450],
      hover: palette.brand.tertiary[100],
      selected: palette.brand.tertiary[100],
    },
    chatBubbles: {
      receivedMessage: {
        background: palette.neutral.grey[100],
        text: palette.neutral.grey[800],
      },
      sentMessage: {
        background: palette.brand.secondary[50],
        text: palette.neutral.grey[800],
      },
    },
    patientTileOptions: {
      default: {
        background: palette.neutral.grey[250],
        icon: palette.neutral.grey[800],
        label: palette.neutral.grey[800],
      },
      hover: {
        background: palette.neutral.grey[400],
        icon: palette.neutral.grey[800],
        label: palette.neutral.grey[800],
      },
      active: {
        background: palette.neutral.grey[100],
        icon: palette.brand.primary[200],
        label: palette.neutral.grey[800],
      },
      disabled: {
        background: palette.neutral.grey[250],
        icon: palette.neutral.grey[450],
        label: palette.neutral.grey[450],
      },
      hoverDestructive: {
        background: palette.alert.negative[350],
        label: palette.neutral.grey[800],
        icon: palette.neutral.grey[100],
      },
    },
    tableCells: {
      default: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[200],
      },
      hover: {
        background: palette.neutral.grey[200],
        border: palette.neutral.grey[200],
      },
      header: {
        background: palette.neutral.grey[150],
        border: palette.neutral.grey[200],
      },
    },
    virtualBackground: {
      setting: {
        default: palette.neutral.grey[200],
        hover: palette.neutral.grey[250],
        selected: palette.neutral.grey[250],
        disabled: palette.neutral.grey[150],
      },
      image: {
        default: palette.neutral.darkAlpha[700],
        hover: palette.neutral.darkAlpha[550],
        selected: palette.neutral.darkAlpha[450],
      },
    },
    location: { border: palette.neutral.grey[400] },
    banner: { background: palette.pro.secondary[10] },
    avatar: {
      background: palette.neutral.grey[400],
      fallback: palette.neutral.grey[400],
    },
    swatch: {
      default: {
        border: palette.neutral.darkAlpha[600],
        background: palette.neutral.grey[100],
      },
    },
    selectionCard: {
      default: {
        true: palette.neutral.grey[150],
        border: palette.neutral.grey[250],
      },
      hover: {
        true: palette.neutral.grey[200],
        border: palette.neutral.grey[250],
      },
      disabled: {
        true: palette.neutral.grey[150],
        border: palette.neutral.grey[250],
      },
    },
    avatarGroup: {
      border: palette.neutral.grey[100],
      counter: palette.neutral.grey[600],
    },
    typingBubbles: {
      1: palette.neutral.grey[300],
      2: palette.neutral.grey[450],
      3: palette.neutral.grey[500],
    },
    paymentSummary: { background: palette.brand.secondary[20] },
    fileContainer: {
      iconBackground: palette.neutral.grey[300],
      background: palette.neutral.grey[150],
      backgroundSecondary: palette.neutral.grey[125],
      strokeSecondary: palette.neutral.grey[250],
    },
    pricingCard: {
      background: palette.neutral.grey[100],
      border: palette.neutral.grey[350],
    },
    microphone: {
      base: palette.neutral.lightAlpha[300],
      fork: palette.neutral.grey[100],
      active: palette.brand.primary[100],
      disabled: palette.neutral.grey[450],
    },
    loader: {
      status: palette.brand.primary[200],
      background: palette.brand.primary[50],
    },
    header: { background: palette.neutral.grey[100] },
    preview: { background: palette.brand.secondary[30] },
    googleButton: {
      default: palette.neutral.grey[150],
      hover: palette.neutral.grey[200],
      pressed: palette.neutral.grey[150],
      disabled: palette.neutral.grey[150],
      label: palette.neutral.grey[800],
      border: palette.neutral.grey[300],
    },
    alertBanner: {
      background: {
        success: palette.alert.positive[150],
        negative: palette.alert.negative[150],
        alert: palette.alert.notice[150],
        informative: palette.alert.informative[150],
      },
      copy: {
        success: palette.neutral.grey[800],
        negative: palette.neutral.grey[800],
        alert: palette.neutral.grey[800],
        informative: palette.neutral.grey[800],
      },
      icon: {
        success: palette.alert.positive[350],
        negative: palette.alert.negative[350],
        alert: palette.alert.notice[350],
        informative: palette.alert.informative[350],
      },
    },
    progressBar: {
      default: palette.neutral.grey[300],
      filled: palette.brand.primary[100],
    },
    pagination: {
      cells: {
        hover: palette.neutral.grey[200],
        selected: palette.neutral.grey[250],
        default: palette.neutral.grey[125],
      },
      base: {
        background: palette.neutral.grey[125],
        border: palette.neutral.grey[200],
      },
    },
    waitingRoom: {
      background: {
        default: palette.neutral.grey[150],
        card: palette.neutral.lightAlpha[100],
        section: palette.neutral.grey[150],
        numberedList: palette.brand.primary[200],
      },
    },
    knob: {
      base: {
        default: palette.neutral.grey[100],
        hover: palette.neutral.grey[150],
        pressed: palette.neutral.grey[100],
        focused: palette.neutral.grey[100],
        disabled: palette.neutral.grey[500],
      },
      stroke: {
        default: palette.neutral.darkAlpha[600],
        hover: palette.neutral.darkAlpha[600],
        pressed: palette.neutral.darkAlpha[600],
        focused: palette.brand.primary[50],
        disabled: palette.neutral.darkAlpha[600],
      },
    },
    slider: {
      track: {
        active: palette.brand.primary[100],
        inactive: palette.brand.primary[50],
        disabledInactive: palette.neutral.grey[450],
        disabledActive: palette.neutral.grey[500],
      },
      dash: { default: palette.neutral.lightAlpha[200] },
    },
    eMDR: {
      background: {
        defaultDark: palette.neutral.grey[800],
        defaultLight: palette.neutral.grey[150],
        hoverDark: palette.neutral.grey[750],
        hoverLight: palette.neutral.grey[250],
      },
      dot: {
        blueOnDark: palette.tint.blue[350],
        blueOnLight: palette.alert.informative[350],
        orangeOnLight: palette.tint.orange[350],
        orangeOnDark: palette.tint.coral[350],
        whiteOnDark: palette.neutral.grey[400],
        greyOnLight: palette.neutral.grey[600],
      },
      stroke: {
        selected: palette.brand.primary[100],
        default: palette.neutral.grey[600],
      },
    },
    apps: {
      background: {
        primaryContainer: palette.neutral.grey[100],
        secondaryContainer: palette.neutral.grey[150],
      },
      menuCards: {
        background: {
          default: palette.neutral.grey[650],
          hover: palette.neutral.grey[600],
        },
        stroke: { default: palette.neutral.lightAlpha[600] },
        assetBackground: { default: palette.neutral.lightAlpha[600] },
      },
      memoryGameCards: {
        background: {
          default: palette.brand.tertiary[10],
          success: palette.alert.positive[350],
        },
      },
      appreciationSpace: {
        selectionCards: {
          background: {
            default: palette.neutral.grey[650],
            hover: palette.neutral.grey[600],
          },
        },
        canvasCards: {
          background: palette.neutral.grey[100],
          stroke: palette.neutral.grey[350],
        },
      },
    },
    viewModeBanner: {
      background: palette.neutral.lightAlpha[100],
      border: palette.neutral.grey[250],
    },
    textBadge: {
      default: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
    },
    loadingSpinner: {
      background: palette.brand.primary[50],
      form: palette.brand.primary[100],
    },
    appsFlyout: {
      cells: {
        default: palette.neutral.grey[800],
        hover: palette.neutral.grey[800],
        selected: palette.neutral.grey[800],
        disabled: palette.neutral.grey[450],
      },
    },
    active: palette.pro.primary[100],
    planBadge: {
      free: {
        border: palette.neutral.grey[550],
        text: palette.neutral.grey[550],
      },
      pro: {
        background: palette.pro.primary[100],
        text: palette.neutral.grey[100],
      },
      clinic: {
        background: palette.neutral.grey[600],
        text: palette.neutral.grey[100],
      },
    },
    scrollBar: { background: palette.neutral.grey[350] },
    illustration: {
      strokes: palette.brand.secondary[70],
      filling: palette.brand.secondary[50],
    },
    dropZone: {
      stroke: {
        default: palette.neutral.darkAlpha[500],
        activeHover: palette.brand.primary[150],
        disabled: palette.neutral.grey[300],
        hover: palette.neutral.darkAlpha[500],
      },
      background: {
        activeHover: palette.brand.primary[25],
        default: palette.neutral.grey[100],
        disabled: palette.neutral.darkAlpha[700],
        hover: palette.neutral.darkAlpha[700],
      },
    },
    timer: {
      countdown: {
        track: palette.neutral.grey[500],
        indicator: palette.brand.primary[150],
      },
      previewSelection: {
        hover: palette.neutral.lightAlpha[500],
        active: palette.brand.primary[50],
      },
      preset: {
        stroke: {
          default: palette.neutral.lightAlpha[550],
          hover: palette.brand.primary[150],
          active: palette.brand.primary[100],
        },
        background: {
          default: palette.neutral.lightAlpha[600],
          disabled: palette.neutral.lightAlpha[650],
        },
      },
    },
    blinkingCursor: { cursor: palette.neutral.grey[800] },
    beta: {
      icon: {
        icon: palette.brand.secondary[80],
        background: palette.brand.secondary[40],
      },
    },
    documentationWrapper: {
      background: palette.neutral.grey[150],
      copy: palette.neutral.grey[800],
      border: palette.neutral.grey[250],
      backgroundBadge: palette.neutral.grey[100],
    },
    appLibraryInfoCard: {
      stroke: palette.neutral.grey[300],
      background: palette.neutral.darkAlpha[700],
    },
    videoPlayerOverlay: {
      default: palette.neutral.darkAlpha[700],
      hover: palette.neutral.darkAlpha[600],
    },
    playButton: {
      stroke: {
        default: palette.neutral.lightAlpha[200],
        hover: palette.neutral.lightAlpha[200],
      },
      background: {
        default: palette.neutral.darkAlpha[400],
        hover: palette.neutral.darkAlpha[300],
      },
      icon: { default: palette.neutral.grey[100] },
    },
    infoIcon: {
      border: palette.neutral.grey[300],
      icon: palette.neutral.grey[800],
      base: palette.neutral.grey[100],
    },
    animatedSpinner: {
      brand: {
        base: palette.neutral.lightAlpha[250],
        spinner: palette.dynamicContrast.primary[100],
      },
      contrast: {
        base: palette.neutral.darkAlpha[500],
        spinner: palette.neutral.grey[800],
      },
      link: {
        base: palette.brand.primary[25],
        spinner: palette.brand.primary[200],
      },
      white: {
        base: palette.neutral.lightAlpha[400],
        spinner: palette.neutral.lightAlpha[100],
      },
    },
    base: palette.neutral.lightAlpha[250],
    spinner: palette.brand.secondary[100],
    skeleton: {
      base: palette.neutral.grey[400],
      shimmer: palette.neutral.grey[100],
      pulse: palette.neutral.grey[300],
    },
    interactiveElement: { disabled: palette.neutral.lightAlpha[300] },
    voiceIndicator: {
      cell: {
        on: palette.neutral.lightAlpha[500],
        off: palette.neutral.lightAlpha[100],
        problem: palette.neutral.lightAlpha[100],
        disabled: palette.neutral.lightAlpha[100],
        loading: palette.neutral.lightAlpha[500],
      },
    },
    appLibraryCard: {
      default: {
        background: palette.neutral.grey[100],
        stroke: palette.neutral.grey[300],
      },
      hover: {
        background: palette.neutral.grey[150],
        stroke: palette.neutral.grey[300],
      },
      selected: {
        background: palette.neutral.grey[100],
        stroke: palette.neutral.grey[300],
        outline: palette.brand.primary[100],
      },
    },
    notificationCenter: {
      divider: palette.neutral.grey[300],
      background: palette.neutral.grey[150],
    },
    roomActivityBadge: {
      waiting: {
        background: palette.alert.informative[350],
        text: palette.neutral.grey[100],
      },
      waitingMessage: {
        background: palette.alert.informative[400],
        text: palette.neutral.grey[100],
      },
      zeroWaiting: {
        background: palette.neutral.grey[100],
        text: palette.neutral.grey[550],
      },
    },
    statusTag: {
      neutral: {
        background: palette.neutral.grey[200],
        copy: palette.neutral.grey[800],
      },
      negative: {
        background: palette.alert.negative[150],
        copy: palette.alert.negative[600],
      },
      notice: {
        background: palette.alert.notice[150],
        copy: palette.alert.notice[600],
      },
      informative: {
        background: palette.alert.informative[150],
        copy: palette.alert.informative[600],
      },
      positive: {
        background: palette.alert.positive[150],
        copy: palette.alert.positive[600],
      },
    },
    closedCaptions: { base: palette.neutral.grey[925] },
    snackbar: {
      background: palette.neutral.grey[100],
      border: palette.neutral.grey[300],
    },
    customConsentFormBuilder: {
      background: palette.neutral.grey[125],
      backgroundPreview: palette.neutral.grey[150],
    },
    whiteboardToolbar: {
      background: palette.neutral.grey[100],
      stroke: palette.neutral.grey[300],
    },
    appsSettingsListItem: {
      background: {
        default: palette.neutral.grey[125],
        hover: palette.neutral.grey[200],
        active: palette.neutral.grey[300],
      },
    },
    whiteboard: { background: palette.neutral.grey[100] },
  }) as const;
